import { Box, Paper, Typography } from "@mui/material";
import { useId, type ReactNode } from "react";

export const PageTile = ({ title, children }: { title?: string; children: ReactNode }) => {
  const titleId = useId();

  return (
    <Paper component="section" variant="outlined" aria-labelledby={title ? titleId : undefined} sx={{ p: 2, minWidth: 0, overflowWrap: "anywhere" }}>
      {title && (
        <Typography id={titleId} component="h3" variant="h6" sx={{ mb: 1 }}>
          {title}
        </Typography>
      )}
      <Box sx={{ typography: "body1" }}>{children}</Box>
    </Paper>
  );
};
